import flatten from 'lodash/flatten';

export const TRANSFER_CREDIT_POLICIES_GENERAL = '_';

export const transferCreditPolicies = {
  [TRANSFER_CREDIT_POLICIES_GENERAL]: [
    'Most credits transfer require manual review',
    'Accepts General Education (GE) courses',
    'Only accepts credits from defined articulation agreements',
  ],
  NY: [
    'General Education - CUNY Common Core Credits',
    'General Education - CUNY College Option Credits',
    'SUNY Guided Pathways',
    'SUNY General Education Requirements (SUNY-GER)',
  ],
  FL: [
    'Statewide Articulation Agreement (2+2)',
    'Industry Certification to AAS/AS',
    'Applied Technology Diploma to Associate of Applied Science/Associate of Science Degree Articulation (ATD to AAS/AS)',
    'Career and Technical Certificate to Associate of Applied Science/ Associate of Science Degree Articulation (CTC/PSAV to AAS/AS)',
    'Associate of Science to Bachelor of Science Degree Articulation (AS to BS)',
    'Statewide Course Numbering System',
  ],
  IL: [
    'Illinois Articulation Initiative (IAI)',
    'General Education Core Curriculum',
    'IAI Majors',
    'The Illinois Associates Degree A.A (GECC)',
    'The Illinois Associates Degree A.S',
  ],
  TX: [
    'Texas Common Course Numbering System (TCCNS)',
  ],
  PA: [
    'PA TRAC',
    'Academic Passport',
  ],
  OH: [
    'Ohio Articulation and Transfer Policy',
    'Ohio Transfer Module',
  ],
  CA: [
    'Accepts California State University (CSU) Breadth courses',
    'Accepts Intersegmental General Education Transfer Curriculum (IGETC) courses\—California-specific', // eslint-disable-line no-useless-escape
  ],
  MA: [
    'MassTransfer',
  ],
  MN: [
    'Minnesota Cooperative Admissions Program',
    'Minnesota Transfer Curriculum',
  ],
  VA: [
    'College Transfer Grant Program (CTG)',
  ],
  NC: [
    'Comprehensive Articulation Agreement (CAA)',
    'Independent Comprehensive Articulation Agreement (ICAA)',
  ],
  GA: [
    'GATRACS',
  ],
  MI: [
    'Michigan Transfer Agreement',
  ],
  WA: [
    'Direct Transfer Agreement',
  ],
  NJ: [
    'NJ Transfer',
  ],
};

export const transferCreditPoliciesPersistedOrder = flatten(Object.keys(transferCreditPolicies)
  .map((section) => (transferCreditPolicies[section])));

export const transferApplicationRequirementsPersistedOrder = [
  'College transcript(s)',
  'Essay or Personal Statement',
  'College Report',
  'High School Transcript',
  'Standardized Test Scores',
  'Letters of Recommendation',
  'Course Descriptions From College Catalog From Each College/University Attended',
  'Academic Evaluation',
];

function createComparator(predefinedOrder) {
  return function comparator(a, b) {
    const aIdx = predefinedOrder.indexOf(a);
    const bIdx = predefinedOrder.indexOf(b);
    if (aIdx === -1 && bIdx === -1) return 0;
    if (aIdx === -1) return 1;
    if (bIdx === -1) return -1;
    if (aIdx < bIdx) return -1;
    /* istanbul ignore else */
    if (aIdx > bIdx) return 1;
    /* istanbul ignore next */
    return 0;
  };
}

export const transferCreditPoliciesComparator = createComparator(transferCreditPoliciesPersistedOrder);
export const transferApplicationRequirementsComparator = createComparator(transferApplicationRequirementsPersistedOrder);
